import { cn } from "@/lib/utils";

export interface PropertyType {
  description: string;
  icon: React.ReactElement;
  id: string;
  title: string;
}

interface PropertyProps extends PropertyType {
  className?: string;
}

export default function Property({
  className,
  description,
  icon,
  title,
}: PropertyProps) {
  return (
    <div
      className={cn(
        "h-[290px] rounded-[30px] bg-eerie-black px-[70px] text-center md:w-[33%] md:px-[25px]",
        className
      )}
    >
      <div className="flex h-[149px] items-center justify-center">{icon}</div>
      <h5 className="font-semibold text-30/[1em]">{title}</h5>
      <h6 className="mt-5 font-normal text-14/[1.86em] text-pale-lavender">
        {description}
      </h6>
    </div>
  );
}
